export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q02_a.440ca049.png";